module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.58050927.jpg";